import { z } from 'zod';
import { Option } from '../../types/Option';

export type MeasurementSignalType = '±20 mA' | '±10 V' | '4–20 mA' | '0–5 V' | '0–10 V';

const options = [
    { value: '±20 mA', label: '±20 mA' },
    { value: '±10 V', label: '±10 V' },
    { value: '4–20 mA', label: '4–20 mA' },
    { value: '0–5 V', label: '0–5 V' },
    { value: '0–10 V', label: '0–10 V' },
] as Option<MeasurementSignalType>[];

const validator = z.enum(['±20 mA', '±10 V', '4–20 mA', '0–5 V', '0–10 V']);

export const MeasurementSignalTypes = {
    validator,
    options,
};
